import React from 'react';
import { useSelector } from 'react-redux';
import { getHeaderStickyMenuShown } from '@yme/components/Header/redux/selectors';
import { useWindowSize } from '@yme/hooks/index';
import { HeroSectionLandingPage } from '@yme/organisms/hero-section';
import { getCommonLabels, getRTL } from '@yme/selectors/common';
import { colorCoreBlack700 } from '@yme/tokens/colors';
import { getOffsetForScrollTo } from '@yme/utils/common';
export function HeroSection(props) {
    const { title, description, image, subtitle, disclaimer, scrollToComponentId, customAspectRatio, isRemoveBottomIndent = false, youtubeId, startTime, } = props;
    const isRightToLeft = useSelector(getRTL);
    const commonLabels = useSelector(getCommonLabels);
    const headerStickyMenuShown = useSelector(getHeaderStickyMenuShown);
    const { isMobileView } = useWindowSize();
    const yOffset = getOffsetForScrollTo({
        isMobileView,
        headerStickyMenuShown,
    });
    return (React.createElement(HeroSectionLandingPage
    // Attention! Default bg-color for this component is 'colorCoreBlack700'
    // (NOT Reuse common approach with getting brand-color through 'getProductBlockStrategy')
    , { 
        // Attention! Default bg-color for this component is 'colorCoreBlack700'
        // (NOT Reuse common approach with getting brand-color through 'getProductBlockStrategy')
        brandedColor: colorCoreBlack700, 
        // Props from AEM
        title: title, subtitle: subtitle, description: description, youtubeId: youtubeId, startTime: startTime, disclaimer: disclaimer, image: image, 
        // Common Component Props
        customAspectRatio: customAspectRatio, isRightToLeft: isRightToLeft, showLessLabel: commonLabels?.common_showLess_button, showMoreLabel: commonLabels?.common_showMore_button, 
        // cta button props
        scrollToComponentId: scrollToComponentId, learnMoreLabel: commonLabels?.common_learnMore_link, 
        // Specific Component Props
        yOffset: yOffset, isRemoveBottomIndent: isRemoveBottomIndent }));
}
HeroSection.displayName = 'HeroSection_AEMComponent_Common';
